var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-container",attrs:{"id":"game-container"}},[_c('div',{staticClass:"box",domProps:{"innerHTML":_vm._s(_vm.text)},on:{"click":_vm.resetCheckStatus}})])}
var staticRenderFns = []

export { render, staticRenderFns }